import { inject, Injectable } from '@angular/core';
import { CollaborationScreenService, CollaborationSidebarFilterUpdate } from '@libs/collaboration';
import { ComponentStore } from '@ngrx/component-store';

const initialState = {
  filterUnreadOnly: false,
  filterDirectOnly: false,
  searchTerm: undefined,
  filterSiteIds: undefined,
};

interface CollabSidebarState {
  filterDirectOnly: boolean;
  filterUnreadOnly: boolean;
  searchTerm?: string;
  filterSiteIds?: string[];
  filterTeamCollab?: boolean;
  filterClinicalCollab?: boolean;
  filterRecentlyDeleted?: boolean;
}

@Injectable({ providedIn: 'root' })
export class CollabSidebarService extends ComponentStore<CollabSidebarState> {
  private readonly collabScreenService = inject(CollaborationScreenService);

  constructor() {
    super(initialState);
  }

  public updateFilters({
    directOnly,
    unreadOnly,
    searchTerm,
    selectedSiteIds,
    teamCollab,
    clinicalCollab,
    recentlyDeleted,
  }: CollaborationSidebarFilterUpdate): void {
    const { filterSiteIds, filterUnreadOnly, filterDirectOnly, filterClinicalCollab, filterTeamCollab, filterRecentlyDeleted } =
      this.state();
    const selectedSiteIdsChanged = selectedSiteIds?.sort().join(',') !== filterSiteIds?.sort().join(',');

    const unreadOnlyChanged = unreadOnly !== filterUnreadOnly;
    const directOnlyChanged = directOnly !== filterDirectOnly;
    const teamCollabChanged = teamCollab !== filterTeamCollab;
    const clinicalCollabChanged = clinicalCollab !== filterClinicalCollab;
    const recentlyDeletedChanged = recentlyDeleted !== filterRecentlyDeleted;
    if (
      searchTerm &&
      searchTerm.length > 0 &&
      searchTerm.length < this.collabScreenService.SEARCH_TERM_MIN_LENGTH &&
      !selectedSiteIdsChanged &&
      !unreadOnlyChanged &&
      !directOnlyChanged &&
      !teamCollabChanged &&
      !clinicalCollabChanged &&
      !recentlyDeletedChanged
    ) {
      return;
    }

    this.patchState({
      filterDirectOnly: directOnly,
      filterUnreadOnly: unreadOnly,
      searchTerm,
      filterSiteIds: selectedSiteIds,
      filterTeamCollab: teamCollab,
      filterClinicalCollab: clinicalCollab,
      filterRecentlyDeleted: recentlyDeleted,
    });
    this.collabScreenService.updateFilters({
      filters: { directOnly, unreadOnly, searchTerm, selectedSiteIds, teamCollab, clinicalCollab, recentlyDeleted },
      clearCollabs: true,
      fetchCollabs: true,
    });
  }

  public leaveCollaboration(collabId: string): void {
    this.collabScreenService.leaveCollaboration({ collabId });
  }

  public recoverCollaboration(collabId: string): void {
    this.collabScreenService.recoverCollaboration({ collabId });
  }

  public deleteCollaboration(collabId: string, isPermanent: boolean): void {
    if (isPermanent) {
      this.collabScreenService.permanentDeleteCollaboration({ collabId });
    } else {
      this.collabScreenService.deleteCollaboration({ collabId });
    }
  }
}
